<template>
     <div v-if="loading" class="loading-page" v-cloak>
                <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
               <img src="../../assets/loading.gif" alt="" class="mt-3">
            <img src="../../assets/logo.svg" alt="" class="logo mt-3">
        </div>
    <div v-else class="obras">

      <main role="main" class="main-carousel container">
        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel">
        <div class="carousel-inner">
             <div v-for="(slide, index) in slide_fotos" :class="{ 'active': index === 0 }" :key="index" class="carousel-item text-center" >

                  <img :src="`https://espais.com.py${slide.url}`" alt="" class="img-fluid imagen-slide">


               <!-- <div class="bg_overlay_carousel">
                  <div>
                    <h1 class="font-weight-bold slide-title">SIERRA CIRCULAR</h1>
                      <a class="slide-btn" href="#">CONSULTAR</a>
                   <h5 class="mt-3"><li class="font-weight-bold">CONSTRUCCION</li></h5>
                  </div>
               </div> -->


           </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
           <i class="fas fa-chevron-left"></i>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
              <i class="fas fa-chevron-right"></i>
            <span class="sr-only">Next</span>
        </a>
        </div>
        <h2 class="text-center" v-if="titulo">{{titulo}}</h2>
        <div class="text-center" v-if="descripcion">{{descripcion}}</div>
    </main>




    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
   components: {
    Carousel,
    Slide
  },
    data () {

    return {
      slide_fotos:[],
      loading:true,
      titulo: '',
      descripcion: '',
      ruta:'',
      nombreBusqueda: ''

    }
  },
  methods: {

       loadLogs () {
       this.$http.get(`https://espais.com.py/admin/api/1.1/tables/${this.$route.params.seccion}/rows/${this.$route.params.id}`,{before:() => {this.loading = true;}})
        .then(function (data) {
          console.log(data.body.data.imagenes_slide.data);
          this.ruta = data.body.meta.table;
        //    this.home = data.body.data;
        this.slide_fotos = data.body.data.imagenes_slide.data;
        this.titulo = data.body.data.titulo;
        this.descripcion = data.body.data.descripcion;
        this.nombreBusqueda = data.body.data.nombre_busqueda;


        }).then(() => {this.loading = false;})
      },
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    }
  },
     mounted () {
    this.$nextTick(function () {
      this.loadLogs();
    })
    }
}
</script>

<style scoped>
.carousel-control-prev, .carousel-control-next{
 font-size: 40px;
 filter: drop-shadow(0 0 7px #000);

}



.imagen-slide{
  max-height: 600px;

}
.links-volver-descripcion{
      font-family: 'Nunito Sans', sans-serif;
    font-weight: 200 !important;
       color: #5f4637 !important;

    cursor: pointer;
    transition: all 1s;
}
.links-volver-descripcion span{
  color: #02666c !important;
  cursor: pointer;
}
.descripcion-obra{
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 10px;
    padding-bottom: 70px;
    display: grid;
    color: white;
    background: rgba(0, 0, 0, 0.5);
}

 .fondo{
   display: flex;
   justify-content: center;

   height:  calc(100vh - 180px);
      width: 100%;

 }
 .init-page{
   background-color: white;
   z-index: 1;
   grid-column: 1/2;
   grid-row:1/4;
 }
.arrowLeft, .arrowRight{
height: 70px;
width: 70px;
position: absolute;
top: 50%;
font-size: 40px;
cursor: pointer;
color: black;
opacity: 0.4;
transition: all 0.7s;
}
.arrowLeft{
  display: flex;
  justify-content: center;
  align-items: center;
 z-index: 1;

}
.arrowLeft:hover{
 opacity: 1;

}
.arrowRight{
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
}
.arrowRight:hover{
 opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/obras/Obra.vue